var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOneLinkManagerActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1504 7.5C17.3503 7.5833 17.538 7.67545 17.7129 7.77539C17.8877 7.87535 18.0668 8.00052 18.25 8.15039L19.7002 7.65039L20.7002 9.40039L19.5498 10.4004C19.5831 10.6003 19.5996 10.8088 19.5996 11.0254C19.5996 11.2419 19.5831 11.4505 19.5498 11.6504L20.7002 12.6504L19.7002 14.3496L18.25 13.9004C18.0669 14.0336 17.8877 14.1457 17.7129 14.2373C17.538 14.3289 17.3503 14.4167 17.1504 14.5L16.8496 16H14.8496L14.5498 14.5C14.3499 14.4167 14.1623 14.3289 13.9873 14.2373C13.8125 14.1457 13.6333 14.0336 13.4502 13.9004L12 14.3496L11 12.6504L12.1504 11.6504C12.1171 11.4171 12.0996 11.2 12.0996 11C12.0996 10.8 12.1171 10.5829 12.1504 10.3496L11 9.34961L12 7.65039L13.4502 8.09961C13.6333 7.96643 13.8125 7.85429 13.9873 7.7627C14.1623 7.67105 14.3499 7.58331 14.5498 7.5L14.8496 6H16.8496L17.1504 7.5ZM15.8496 9C15.2998 9.00009 14.8291 9.19632 14.4375 9.58789C14.046 9.97952 13.8496 10.4501 13.8496 11C13.8496 11.5499 14.046 12.0205 14.4375 12.4121C14.8291 12.8037 15.2998 12.9999 15.8496 13C16.3996 13 16.871 12.8038 17.2627 12.4121C17.6542 12.0205 17.8496 11.5499 17.8496 11C17.8496 10.4501 17.6542 9.9795 17.2627 9.58789C16.871 9.19622 16.3996 9 15.8496 9Z",
    fill: "#5F11EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2H5C4.16667 2 3.45833 2.29167 2.875 2.875C2.29167 3.45833 2 4.16667 2 5C2 5.83333 2.29167 6.54167 2.875 7.125C3.45833 7.70833 4.16667 8 5 8H9V10H5C3.61667 10 2.43789 9.51211 1.46289 8.53711C0.487891 7.56211 0 6.38333 0 5C0 3.61667 0.487891 2.43789 1.46289 1.46289C2.43789 0.487891 3.61667 0 5 0H9V2Z",
    fill: "#5F11EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H6V4H14V6Z",
    fill: "#5F11EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C16.3833 0 17.5621 0.487891 18.5371 1.46289C19.5121 2.43789 20 3.61667 20 5H18C18 4.16667 17.7083 3.45833 17.125 2.875C16.5417 2.29167 15.8333 2 15 2H11V0H15Z",
    fill: "#5F11EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOneLinkManagerActive);
export default __webpack_public_path__ + "static/media/icon-one-link-manager-active.e121f1b1aeb6f9a5f6d665d55f96bb1e.svg";
export { ForwardRef as ReactComponent };